import { Tooltip, type TooltipProps } from 'antd'
import { type ReactNode } from 'react'

import WarningIcon from '@/assets/images/warning.svg?react'
import { Trans } from '@/components'

type SelectMachineTooltipProps = {
  children: ReactNode
  enabled: boolean
  className?: string
  placement?: TooltipProps['placement']
}

type DisabledActionTooltipProps = SelectMachineTooltipProps & {
  title: ReactNode
}

const tooltipInnerStyle: TooltipProps['overlayInnerStyle'] = {
  backgroundColor: 'rgba(14, 18, 27, 0.8)',
  borderRadius: 8,
  boxShadow: 'none',
  padding: 8,
}

function TooltipTitle({ children }: { children: ReactNode }) {
  return (
    <div className="flex max-w-[480px] items-center justify-center gap-2 text-left">
      <WarningIcon className="h-4 w-4 shrink-0 [&_path]:fill-white" />
      <span className="t-sm text-white">{children}</span>
    </div>
  )
}

export function DisabledActionTooltip({
  children,
  enabled,
  title,
  className,
  placement = 'right',
}: DisabledActionTooltipProps) {
  if (!enabled) return <>{children}</>

  return (
    <Tooltip
      title={<TooltipTitle>{title}</TooltipTitle>}
      placement={placement}
      mouseEnterDelay={0}
      arrow={false}
      overlayInnerStyle={tooltipInnerStyle}
    >
      <span className={className || 'inline-block align-top'}>{children}</span>
    </Tooltip>
  )
}

export function SelectMachineTooltip(props: SelectMachineTooltipProps) {
  return (
    <DisabledActionTooltip
      {...props}
      title={<Trans i18nKey="create.selectMachineTooltip">Please select an instance first</Trans>}
    />
  )
}
